// import { getToken, clearToken } from './auth'
// import { navigate } from 'svelte-routing'
import { stringify } from 'query-string';
import { get } from 'svelte/store';
import { user } from './store';

const API_URL = 'FD_API';
const WEB_URL = 'FD_WEB';

export function APIError(message, errors) {
  this.message = message;
  this.errors = errors || {};
}

export function notify(message) {
  const myEvent = new CustomEvent('notify', { detail: message });

  window.dispatchEvent(myEvent);
}

export async function apiCall(path, params = {}) {
  params.headers = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    ...(params.headers || {}),
  };

  if (typeof path == 'string') {
    path = [path];
  }
  path.unshift(API_URL);
  let resource = path.join('/');

  if (params.query) {
    if (Object.keys(params.query).length) {
      resource = `${resource}?${stringify(params.query)}`;
    }
    delete params.query;
  }

  if (params.headers['Content-Type'] == 'application/json' && params.body) {
    params.body = JSON.stringify(params.body);
  }

  const token = get(user).token;
  if (token) {
    params.headers.Authorization = 'Bearer ' + token;
  }

  let response;

  try {
    try {
      response = await fetch(resource, params);
    } catch (error) {
      // Pre-flight errors may be caught here

      throw new APIError(
        `Operation failed, please try again. Error: '${error.message}'`
      );
    }

    if (response.status === 200) {
      return response;
    } else if (response.status === 401) {
      auth.signOut();
    } else if (response.status >= 400) {
      const resp = await response.json();
      throw new APIError(resp.error.message, resp.error.issues);
    }
  } catch (e) {
    if (e instanceof APIError) {
      notify(e);
    }
    throw e;
  }

  return response;
}

export async function apiGet(path, params) {
  const response = await apiCall(path, { query: params, method: 'GET' });
  const data = await response.json();
  return data;
}

export async function apiGetMany(path, options) {
  let query = {};

  const { filter, sort, pagination } = options;

  if (filter && Object.keys(filter).length) {
    query['filter'] = JSON.stringify(filter);
  }

  if (sort && sort.length) {
    query['sort'] = JSON.stringify(sort);
  }

  if (pagination) {
    const { pageNo, pageSize } = pagination;
    if (pageSize) {
      query['page_no'] = JSON.stringify(parseInt(pageNo));
      query['page_sz'] = JSON.stringify(parseInt(pageSize));
    }
  }

  const response = await apiCall(path, { query, method: 'GET' });
  const data = await response.json();
  return {
    data,
    pagination: getPagination(
      response,
      pagination ? pagination.pageSize : null
    ),
  };
}

export async function apiPost(path, body, message) {
  const response = await apiCall(path, { method: 'POST', body });

  let data = null;
  if (response.status !== 204) {
    data = await response.json();
  }
  if (response.status >= 200 && response.status < 300 && message) {
    notify({ message: message });
  }
  return data;
}

export async function apiUpdate(path, body) {
  const response = await apiCall(path, { method: 'PUT', body });
  const data = await response.json();
  if (response.status == 200) {
    notify({ message: 'Update Successful' });
  }
  return data;
}

export async function apiCreate(resource, body) {
  const data = apiPost(resource, body, 'Created');
  return data;
}

export async function apiDelete(path, body) {
  const response = await apiCall(path, { method: 'DELETE', body });
  let data = null;
  if (response.status == 200) {
    data = await response.json();
  }
  notify({ message: 'Deleted' });
  return data;
}

export function getPagination(response, pageSize) {
  try {
    const header = response.headers.get('content-range');
    if (header) {
      const groups = header.match(/bytes (\d+)-(\d+)\/(\d+)/);
      const pageCount = parseInt(groups[3] / pageSize) + 1;
      if (groups.count % pageSize === 0) {
        pageCount += 1;
      }
      return {
        pageStart: parseInt(groups[1]),
        pageEnd: parseInt(groups[2]),
        count: parseInt(groups[3]),
        pageNo: parseInt(groups[1] / pageSize) + 1,
        pageCount: pageCount,
        pageSize: pageSize,
      };
    }
  } catch (err) {}
  return null;
}

export const download = async (path, dfltFileName) => {
  const token = getToken();
  try {
    const response = await fetch(`${WEB_URL}${path}`, {
      headers: { Authorization: `Bearer ${token}` },
    });

    const blob = await response.blob();
    // 2. Create blob link to download
    const url = window.URL.createObjectURL(blob);
    // window.open(url);

    const link = document.createElement('a');
    link.href = url;
    const fileName = response.headers.get('x-filename');
    link.setAttribute('download', fileName ? fileName : dfltFileName);
    // 3. Append to html page
    document.body.appendChild(link);
    // 4. Force download
    link.click();
    // 5. Clean up and remove the link
    link.parentNode.removeChild(link);
  } catch (error) {
    notify(error.body.error.message);
  } finally {
  }
};

export function openPage(path) {
  window.open(`${WEB_URL}${path}`);
}
